import React from 'react';
import { CheckCircle, Mail, Clock, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export const AdvisorSignupSuccessPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        {/* Success Icon */}
        <div className="w-20 h-20 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-10 h-10 text-white" />
        </div>

        {/* Header */}
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Demande envoyée !
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          Votre demande pour devenir accompagnateur ESS a été transmise avec succès.
        </p>

        {/* Steps */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 mb-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Prochaines étapes</h2>
          
          <div className="space-y-4">
            <div className="flex items-start space-x-3">
              <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-blue-600 text-sm font-medium">1</span>
              </div>
              <div className="text-left">
                <p className="font-medium text-gray-900">Examen de votre dossier</p>
                <p className="text-sm text-gray-600">Les coordinateurs CRESS examinent votre candidature</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3">
              <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-blue-600 text-sm font-medium">2</span>
              </div>
              <div className="text-left">
                <p className="font-medium text-gray-900">Validation par les coordinateurs</p>
                <p className="text-sm text-gray-600">Les coordinateurs reçoivent une notification de votre demande</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-3">
              <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-blue-600 text-sm font-medium">3</span>
              </div>
              <div className="text-left">
                <p className="font-medium text-gray-900">Activation du compte</p>
                <p className="text-sm text-gray-600">Votre compte sera créé lors de l'approbation</p>
              </div>
            </div>
          </div>
        </div>

        {/* Info Cards */}
        <div className="grid grid-cols-1 gap-4 mb-8">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-center space-x-2 mb-2">
              <Mail className="w-5 h-5 text-blue-600" />
              <h3 className="font-medium text-blue-900">Demande enregistrée</h3>
            </div>
            <p className="text-sm text-blue-800">
              Votre demande a été enregistrée et transmise aux coordinateurs CRESS.
            </p>
          </div>
          
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
            <div className="flex items-center space-x-2 mb-2">
              <Clock className="w-5 h-5 text-orange-600" />
              <h3 className="font-medium text-orange-900">Délai de traitement</h3>
            </div>
            <p className="text-sm text-orange-800">
              Votre demande sera examinée par les coordinateurs sous 48h. Votre compte sera créé lors de l'approbation.
            </p>
          </div>
        </div>

        {/* Actions */}
        <div className="space-y-4">
          <Link
            to="/login"
            className="inline-flex items-center space-x-2 px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors font-medium"
          >
            <span>Retour à l'accueil</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
          
          <p className="text-sm text-gray-500">
            Votre compte sera créé automatiquement lors de l'approbation de votre demande
          </p>
        </div>

        {/* Contact */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-600">
            Questions ? Contactez-nous à{' '}
            <a 
              href="mailto:accompagnement@cress-guadeloupe.org" 
              className="text-blue-600 hover:text-blue-700 font-medium"
            >
              accompagnement@cress-guadeloupe.org
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};